/**
 * Centralized error messages for consistent UX across the application
 */

export const SESSION_EXPIRED_MESSAGE =
  "Your browser requires a refresh. Please logout and log back into Factory.";
